// Built-in sample rotas, so anyone can try ShiftLens without a file of their own.
// Synthetic data only (CLAUDE.md): fictional people and venues. Each sample is bundled
// with the app and loaded on demand, so trying one makes no network request beyond the
// app's own script chunk.

export interface Sample {
  id: string;
  /** Button label. */
  label: string;
  /** One line on what the sample shows. */
  description: string;
  fileName: string;
  load(): Promise<string>;
}

export const SAMPLES: Sample[] = [
  {
    id: 'pub',
    label: 'A pub',
    description: '3 weeks, 5 staff, including a 17-year-old on late shifts',
    fileName: 'the-example-arms.csv',
    load: () => import('./the-example-arms.csv?raw').then((m) => m.default),
  },
  {
    id: 'cafe',
    label: 'A café',
    description: '2 weeks, 4 staff, including a 16-year-old on long days',
    fileName: 'example-cafe.csv',
    load: () => import('./example-cafe.csv?raw').then((m) => m.default),
  },
  {
    id: 'shop',
    label: 'A shop with two sites',
    description: '2 weeks, 4 staff, one of them working at both sites',
    fileName: 'sample-stores.csv',
    load: () => import('./sample-stores.csv?raw').then((m) => m.default),
  },
];

/** The sample as a File, so it goes through exactly the same import as an upload. */
export async function sampleFile(sample: Sample): Promise<File> {
  return new File([await sample.load()], sample.fileName, { type: 'text/csv' });
}
